"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adaptStorage = exports.parseCombinedTimestamp = exports.parseCombinedValue = void 0;
const parseCombinedValue = (combinedValueString) => {
    if (!combinedValueString) {
        return null;
    }
    try {
        const combinedValue = JSON.parse(combinedValueString);
        return combinedValue.value;
    }
    catch {
        return null;
    }
};
exports.parseCombinedValue = parseCombinedValue;
const parseCombinedTimestamp = (combinedValueString) => {
    if (!combinedValueString) {
        return null;
    }
    try {
        const combinedValue = JSON.parse(combinedValueString);
        return combinedValue.timestamp;
    }
    catch {
        return null;
    }
};
exports.parseCombinedTimestamp = parseCombinedTimestamp;
const adaptStorage = (storage) => {
    const getItem = async (key) => {
        if (storage.getItem) {
            const combinedValueString = await storage.getItem(key);
            return (0, exports.parseCombinedValue)(combinedValueString);
        }
        else if (storage.getGenericPassword) {
            const genericPassword = await storage.getGenericPassword();
            if (genericPassword) {
                const combinedValueString = genericPassword.password;
                return (0, exports.parseCombinedValue)(combinedValueString);
            }
            return null;
        }
        return null;
    };
    const setItem = async (key, value) => {
        const now = new Date();
        const timestamp = Math.floor(now.getTime() / 1000);
        const combinedValue = {
            timestamp,
            value,
        };
        const combinedValueString = JSON.stringify(combinedValue);
        if (storage.setItem) {
            await storage.setItem(key, combinedValueString);
            if (key === 'accessToken') {
                await storage.setItem('accessToken', value);
            }
        }
        else if (storage.setGenericPassword) {
            await storage.setGenericPassword(key, combinedValueString);
        }
    };
    const removeItem = async (key) => {
        if (storage.removeItem) {
            const isRemoved = await storage.removeItem(key);
            return !!isRemoved;
        }
        else if (storage.resetGenericPassword) {
            const isRemoved = await storage.resetGenericPassword();
            return isRemoved;
        }
        return false;
    };
    const getTimestamp = async (key) => {
        if (storage.getItem) {
            const combinedValueString = await storage.getItem(key);
            return (0, exports.parseCombinedTimestamp)(combinedValueString);
        }
        else if (storage.getGenericPassword) {
            const genericPassword = await storage.getGenericPassword();
            if (genericPassword) {
                const combinedValueString = genericPassword.password;
                const combinedValue = JSON.parse(combinedValueString);
                const timestamp = combinedValue.timestamp;
                return timestamp;
            }
            return null;
        }
        return null;
    };
    return { getItem, setItem, removeItem, getTimestamp };
};
exports.adaptStorage = adaptStorage;
